export default {
    notifierTimeout: 10000, // millisecond
    requestTimeout: 10000, // millisecond
    throttleTimeout: 300 // millisecond
};
